import { render, staticRenderFns } from "./EditAssignment.vue?vue&type=template&id=6d885fd8&"
import script from "./EditAssignment.vue?vue&type=script&lang=js&"
export * from "./EditAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports